module.exports = __webpack_public_path__ + "static/media/todos-follow-up.dac387d6.svg";